import { Component, Inject, Renderer2, ElementRef } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent {
  message: SafeHtml;
  
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any, 
    private sanitizer: DomSanitizer,
    private renderer: Renderer2, 
    private el: ElementRef
  ) {
    this.renderer.addClass(this.el.nativeElement, this.data.type);
    // sanitize the message
    this.message = sanitizer.bypassSecurityTrustHtml(data.message);
  }
}
